<template>
  <v-layout column>
    <v-flex v-if="apiCallPending">
      <v-progress-linear indeterminate> </v-progress-linear>
    </v-flex>
    <v-flex v-else>
      <v-card>
        <v-layout row justify-end>
          <v-flex class="text-xs-right">
            <v-btn @click="requestReviewDialog = true" color="primary"
              >Request New Evaluation</v-btn
            >
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="reviews"
          item-key="id"
          :pagination.sync="defaultSort"
          class="elevation-1"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <!-- <td>{{ item.fulfilled }}</td> -->
              <td>{{ item.locationName }}</td>
              <td>{{ item.authorName }}</td>
              <td v-if="item.fulfilledAt">
                <!--
                <router-link :to="{ name: 'shiftDetail', params: { shiftId: item.id } }">
                  {{ item.startDatetime | moment('MMMM DD YYYY, h:mma') }}
                </router-link>
                -->
                {{ item.fulfilledAt | moment('MMMM DD YYYY, h:mma') }}
              </td>
              <td v-else>
                Not yet written by employee
              </td>
              <td>
                <v-rating
                  half-increments
                  v-if="item.rating"
                  v-model="item.rating"
                  readonly
                  length="4"
                />
              </td>
              <td>
                <v-btn
                  v-if="item.fulfilledAt"
                  @click="setDetailsDialogContentTo(item)"
                  >View Details</v-btn
                >
              </td>
              <td>
                <v-tooltip top v-if="!item.fulfilledAt">
                  <v-icon slot="activator" @click="sendRequestMessage(item)"
                    >mail</v-icon
                  >
                  <span>Re-send request</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <v-dialog v-model="requestReviewDialog" max-width="400">
      <v-card>
        <v-card-text>
          <v-select
            label="Location for Evaluation"
            :items="clientBusiness.locations"
            item-text="name"
            item-value="id"
            v-model="reviewingLocationId"
            :disabled="requestPending"
          />
          <v-autocomplete
            label="Request from Employee"
            :items="reviewableEmployees"
            :disabled="!reviewingLocationId || gettingReviewableEmployees || requestPending"
            :loading="gettingReviewableEmployees"
            item-text="display_name"
            item-value="id"
            v-model="requestFromEmployeeId"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            flat
            @click="requestReviewDialog = false"
            :loading="requestPending"
            :disabled="requestPending"
            >Nevermind</v-btn
          >
          <v-btn
            color="success"
            @click="requestReview"
            :loading="requestPending"
            :disabled="requestPending"
            >Send Request</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="detailsDialogContent"
      v-model="detailsDialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline"
            >{{ detailsDialogContent.authorName }}'s Evaluation for {{
            detailsDialogContent.locationName }}</span
          >
        </v-card-title>

        <v-card-text>
          <p>
            <strong>Requested By:</strong> {{ detailsDialogContent.requesterName
            }} on {{ detailsDialogContent.createdAt | moment('MMMM DD YYYY') }}
          </p>
          <p><strong>Author:</strong> {{ detailsDialogContent.authorName }}</p>

          <div v-if="detailsDialogContent.fulfilled">
            <p>
              <strong>Written on:</strong>
              {{ detailsDialogContent.fulfilledAt | moment('MMMM DD YYYY') }}
            </p>

            <!-- Legacy evaluations: single rating + single text -->
            <div v-if="detailsDialogContent.legacyFormat">
              <v-textarea readonly label="Evaluation" box v-model="detailsDialogContent.review" />
            </div>

            <!-- New evaluations: 4 ratings + 2 texts -->
            <div v-else>
              <div class="mb-3">
                <strong>Overall clinic rating</strong>
                <v-rating readonly half-increments length="4" v-model="detailsDialogContent.rating" />
              </div>
              <div class="mb-3">
                <strong>How welcoming was the clinic's team?</strong>
                <v-rating readonly half-increments length="4" v-model="detailsDialogContent.welcomingRating" />
              </div>
              <div class="mb-3">
                <strong>How willing was the clinic team to answer questions and provide guidance when asked?</strong>
                <v-rating readonly half-increments length="4" v-model="detailsDialogContent.guidanceRating" />
              </div>
              <div class="mb-3">
                <strong>How well did the cases/tasks match your skills and experience level?</strong>
                <v-rating readonly half-increments length="4" v-model="detailsDialogContent.skillsMatchRating" />
              </div>

              <v-textarea
                v-if="detailsDialogContent.returnLikelihoodText"
                readonly box
                label="Are you likely to return to this hospital? If not, why?"
                v-model="detailsDialogContent.returnLikelihoodText"
              />
              <p v-else><em>(No response to return-likelihood question)</em></p>

              <v-textarea
                v-if="detailsDialogContent.managerNotesText"
                readonly box
                label="What should VSS managers know about this hospital before sending another relief employee?"
                v-model="detailsDialogContent.managerNotesText"
              />
              <p v-else><em>(No notes for VSS managers)</em></p>
            </div>
          </div>

          <div v-else>
            <p class="headline">Not yet written</p>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDetails">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    props: ['clientBusiness'],
    components: {},
    computed: {
      ...mapState('userAuth', ['user']),
      exampleComputed: function() {
        return this.example;
      },
    },
    created() {
      this.setUp();
    },
    watch: {
      reviewingLocationId(val) {
        if (val) {
          this.requestFromEmployeeId = null;
          this.getReviewableEmployeesForLocation(val);
        } else {
          this.reviewableEmployees = [];
        }
      },
      requestReviewDialog(val) {},
      detailsDialog(val) {
        val || this.closeDetails();
      },
    },
    data: function() {
      return {
        defaultSort: {
          sortBy: 'createdAt',
          ascending: true,
          rowsPerPage: 25,
        },
        headers: [
          // {text: 'Fulfilled?', value: 'fulfilled'},
          {text: 'Location', value: 'locationName'},
          {text: 'Author', value: 'authorName'},
          {text: 'Date Written', value: 'fulfilledAt'},
          {text: 'Rating', value: 'rating'},
          {text: 'Evaluation', value: ''},
        ],
        apiCallPending: false,
        reviews: [],
        detailsDialog: false,
        detailsDialogContent: null,
        requestReviewDialog: false,
        reviewingLocationId: null,
        requestPending: false,
        reviewableEmployees: [],
        gettingReviewableLocations: false,
        gettingReviewableEmployees: false,
        requestFromEmployeeId: null,
      };
    },
    methods: {
      sendRequestMessage(request) {
        this.$store
          .dispatch('clientBusinesses/resendRequest', request)
          .then(res => {
            this.$store.dispatch(
              'global/showSnackbarSuccess',
              {message: `The request was sent to ${request.authorName} again.`},
              {root: true},
            );
          })
          .catch(e => {
            this.$store.dispatch(
              'global/showSnackbarError',
              {message: 'Something went wrong sending that request'},
              {root: true},
            );
          })
          .finally(r => {});
      },
      requestReview() {
        this.requestPending = true;

        const params = {
          location_review_params: {
            worksite_id: this.reviewingLocationId,
            author_id: this.requestFromEmployeeId,
          },
        };

        this.$store
          .dispatch('clientBusinesses/createLocationReviewRequest', params)
          .then(res => {
            this.reviews = this.reviews.concat(res);
            // TODO: add in to existing reviews
            this.$store.dispatch(
              'global/showSnackbarSuccess',
              {message: 'The evaluation request has been sent!'},
              {root: true},
            );
          })
          .catch(e => {
            this.$store.dispatch(
              'global/showSnackbarError',
              {message: 'Something went wrong sending that request'},
              {root: true},
            );
          })
          .finally(r => {
            this.requestPending = false;
            this.requestReviewDialog = false;
            this.reviewingLocationId = null;
            this.requestFromEmployeeId = null;
          });

        // TODO: demo/remove:
        //setTimeout(() => {
        //this.requestPending = false;
        //this.requestReviewDialog = false;
        //this.reviewingLocationId = null;
        //this.requestFromEmployeeId = null;
        //}, 1000)
      },
      setDetailsDialogContentTo(reviewContent) {
        this.detailsDialogContent = reviewContent;
        this.detailsDialog = true;
      },
      closeDetails() {
        this.detailsDialog = false;
      },
      getReviewableEmployeesForLocation(locationId) {
        this.gettingReviewableEmployees = true;
        this.$store
          .dispatch(
            'clientBusinesses/getReviewableEmployeesForLocation',
            locationId,
          )
          .then(res => {
            this.reviewableEmployees = res;
          })
          .finally(() => {
            this.gettingReviewableEmployees = false;
          });
      },
      setUp() {
        this.apiCallPending = true;
        let params = {
          //startDate: this.$moment().subtract(100, "years").format("YYYY-MM-DD"),
          //endDate: this.$moment().add(100, "years").format("YYYY-MM-DD"),
          // locationFilter: this.clientBusiness.locations.map(l => l.id),
          clientBusinessId: this.clientBusiness.id,
        };
        this.$store
          .dispatch('clientBusinesses/getReviews', params)
          .then(res => {
            this.reviews = res;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(res => {
            this.apiCallPending = false;
          });
      },
    },
  };
</script>

<style scoped></style>
